import React from 'react';
import MainLayout from './MainLayout/MainLayout';

const Layout = ({ children }) => {
  return <MainLayout>{children}</MainLayout>;
};

export default Layout;
